import { render } from "./CarsView.vue?vue&type=template&id=972f3e1e&scoped=true&lang=pug"
import script from "./CarsView.vue?vue&type=script&lang=js"
export * from "./CarsView.vue?vue&type=script&lang=js"

import "./CarsView.vue?vue&type=style&index=0&id=972f3e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972f3e1e"]])

export default __exports__